import { lazy } from 'react';
import i18next from 'i18next';
import { ResourceCenterIcon } from '@shared/ui/icons';

const ResourceCenter = lazy(() => import('../../../../../pages/resource-center'));

// PROTOTYPE (2026-08-25): wireframe for the new Resource Center hub
// per the customer's initial requirements draft. No permission gate —
// the hub is meant for every authenticated account; the AllergiEnd
// block inside the page gates itself on
// ACCOUNT_GET_ALLERGIEND_RESOURCES.
const RESOURCE_CENTER_PATH = '/:currentAccountUuid/resource-center';

const RESOURCE_CENTER_DASHBOARD = {
  path: RESOURCE_CENTER_PATH,
  exact: true,
  additional: {
    component: ResourceCenter,
    protected: true,
    title: i18next.t('titles:resourceCenter'),
    icon: ResourceCenterIcon,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.resourceCenter || 'Resource Center',
    },
  },
};

// Sections and lessons are child routes of the hub, so a reload or a
// shared link lands on the open section and the browser Back button
// steps out of it. The page itself decides what each section shows.
const SECTION_LABELS = {
  catalog: 'Products & Services',
  news: "What's New",
  training: 'Training',
  guides: 'Guides & Resources',
  billing: 'Billing & Reimbursement',
  faq: 'FAQs & Support',
};

const RESOURCE_CENTER_SECTION = {
  path: `${RESOURCE_CENTER_PATH}/:section`,
  exact: true,
  parentRoute: RESOURCE_CENTER_DASHBOARD,
  additional: {
    component: ResourceCenter,
    protected: true,
    title: i18next.t('titles:resourceCenter'),
    icon: ResourceCenterIcon,
    breadcrumb: {
      isRoot: false,
      parentPath: RESOURCE_CENTER_PATH,
      label: ({ params }) => SECTION_LABELS[params?.section] || 'Resource Center',
    },
  },
};

const RESOURCE_CENTER_LESSON = {
  path: `${RESOURCE_CENTER_PATH}/lesson/:lessonId`,
  exact: true,
  parentRoute: RESOURCE_CENTER_DASHBOARD,
  additional: {
    component: ResourceCenter,
    protected: true,
    title: i18next.t('titles:resourceCenter'),
    icon: ResourceCenterIcon,
    breadcrumb: {
      isRoot: false,
      parentPath: RESOURCE_CENTER_PATH,
      label: () => 'Lesson',
    },
  },
};

export const RESOURCE_CENTER_ROUTES = {
  dashboard: RESOURCE_CENTER_DASHBOARD,
  section: RESOURCE_CENTER_SECTION,
  lesson: RESOURCE_CENTER_LESSON,
};
